




































































































import PaginateModel from "@/model/paginate";
import Vue from "vue";
import Component from "vue-class-component";
import {
  AwsService as awsApi,
  CatalogsManagerService as catalogApi,
} from "@/common/api";
import QPaginate from "@/common/qPaginate.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import { CATEGORIES } from "@/model/catalog";
import CatalogEdit from "@/pages/catalog/edit.vue";
import qNotify from "@/common/qNotify";
import { formatImageUrl } from "@/common/utils";

@Component({
  name: "CatalogIndex",
  components: {
    QPaginate,
    QTableHeader,
    CatalogEdit,
  },
})
export default class CatalogIndex extends Vue {
  public catalogs = [];

  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public searchParams = {
    title: "",
    sort: "created_at",
    direction: "desc",
    category: "",
  };

  public headers = [
    { id: "created_at", name: "登録日", order: "desc" },
    { id: "category", name: "カテゴリ", order: "" },
    { id: "image", name: "画像" },
    { id: "title", name: "タイトル", order: "" },
    { id: "", name: "ページ数" },
    { id: "", name: "DL資料" },
    { id: "", name: "" },
  ];

  get categories() {
    return CATEGORIES;
  }

  mounted() {
    this.filter(false, {}, true);
    this.getList({});
  }

  public async getList(query: any) {
    const parameters = { ...query };

    const { data } = await catalogApi.catalogs(parameters);
    this.pagination = new PaginateModel({
      page: data.paginator.currentPage,
      pageCount: data.paginator.lastPages,
      start: data.paginator.currentPage,
      end: data.paginator.lastPages,
      count: data.paginator.total,
    });
    this.catalogs = data.list;
  }

  public filter(clear = false, addition = {}, firstLoad = false): void {
    let { name, params, query } = this.$router.currentRoute;
    if (clear) {
      query = {};
    }

    query = {
      ...this.searchParams,
      ...query,
      ...addition,
    };

    if (firstLoad) {
      this.searchParams = Object.assign(query);
    }

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public async doSearch(query: any) {
    await this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public clear() {
    this.searchParams = {
      title: "",
      sort: "created_at",
      direction: "desc",
      category: "",
    };
    this.$router.replace({ query: {} });
    this.doSearch({});
    this.filter(true);
  }

  public showCatalogEditPopup(catalog = null) {
    (this.$refs.catalogEditPopup as CatalogEdit).show(catalog);
  }

  async showFile(filePath, fileType) {
    try {
      if (fileType === "none") {
        return;
      }

      window.open(filePath, "_blank");
      return;

      // if (fileType === "url") {
      //   window.open(filePath, "_blank");
      //   return;
      // }
      // const result = await awsApi.awsDownloadFilePresign({
      //   filePath: filePath,
      // });
      //
      // fetch(result.data.presign.url, { method: "GET" })
      //   .then((response) => {
      //     return response.blob();
      //   })
      //   .then((blob) => {
      //     var url = window.URL.createObjectURL(blob);
      //     window.open(url, "_blank");
      //   });
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }

  async downFile(file, fileUrl, fileType) {
    try {
      if (fileType === "none") {
        return;
      }

      if (fileType === "url") {
        window.open(fileUrl);
        return;
      }
      const result = await awsApi.awsDownloadFilePresign({
        filePath: file.name,
      });

      fetch(result.data.presign.url, { method: "GET" })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          let aTag = document.createElement("a");
          aTag.href = url;
          aTag.download = file.nameOriginal;
          document.body.append(aTag);
          aTag.click();
          aTag.remove();
        });
    } catch (error) {
      qNotify.error({
        text: error.message,
      });
    }
  }

  public formatImage(image) {
    return formatImageUrl(image.name);
  }
}
